export default __webpack_public_path__ + "static/media/mondayoff_logo_03.7574e558.png";